import {FC} from 'react'
import {Link} from 'react-router-dom'
import ActionButton from 'jbc-front/components/ActionButton'
import {Edit, User, Visibility} from 'jbc-front/components/icons'
import {Employee} from 'types/api/employees/employee'
import {FlatCard, FlatCardBody, FlatCardHeader, FlatCardTitle} from '../FlatCard'
import styles from './Profile.scss'

interface ProfileProps {
  employee: Employee
}

export const Profile: FC<ProfileProps> = ({employee}) => {
  const groups = getGroups(employee)

  return (
    <FlatCard className={styles.profile}>
      <FlatCardHeader border>
        <FlatCardTitle>プロフィール</FlatCardTitle>
        <div className={styles.actions}>
          <ActionButton as={Link} icon={<Edit />} to="/account_settings/profile/edit">
            編集
          </ActionButton>
          <ActionButton as={Link} icon={<Visibility />} to="/account_settings/profile">
            閲覧
          </ActionButton>
        </div>
      </FlatCardHeader>
      <FlatCardBody className={styles.profileBody}>
        <div className={styles.profileImageSection}>
          {employee.icon?.url ? (
            <div style={{backgroundImage: `url("${employee.icon.url}")`}} className={styles.profileImage} />
          ) : (
            <User className={styles.profileImage} size={74} />
          )}
        </div>
        <div className={styles.profileDescriptionSection}>
          <div className={styles.profileName}>{employee.display_full_name}</div>
          <div className={styles.profileEmail}>{employee.email}</div>
          {employee.personnel_history?.occupation_name && (
            <div className={styles.profileOccupation}>{employee.personnel_history.occupation_name}</div>
          )}
          {groups.length > 0 && (
            <div className={styles.profileGroup}>
              {groups.map((group, index) => (
                <span key={index}>
                  {wrapArrowText(group)}
                  {index < groups.length - 1 && <span>&#47;</span>}
                </span>
              ))}
            </div>
          )}
        </div>
      </FlatCardBody>
    </FlatCard>
  )
}

const getGroups = (employee: Employee): string[] =>
  employee.personnel_history
    ? [
        employee.personnel_history.group_0_name,
        employee.personnel_history.group_1_name,
        employee.personnel_history.group_2_name,
      ]
        .filter((v) => v !== undefined)
        .filter((v) => v)
    : []

// グループ名区切りの矢印を途中で折り返さないようにする
const wrapArrowText = (source: string) => {
  return source.split('->').flatMap((text, index) =>
    index === 0
      ? text
      : [
          <span className={styles.arrowText} key={index}>
            -&gt;
          </span>,
          text,
        ]
  )
}
